import { useDispatch } from 'react-redux';
import { ReactElement } from 'react';

import config from 'config';

import { setGender } from 'redux/onboadring/actions';

import { sendGTMStartPageEvent } from 'services/Analytics/trackers/GTMtrakers';
import { sendAnalyticLogin, sendAnalyticOptionEventLabel } from 'services/Analytics';

import withStartHOC from 'HOC/withStartHOC';

import StartWithCardsContainer from 'containers/StartContainers/StartWithCardsContainer';

import { ICommonPageProps } from 'types/pages/startPages/commonTypes';
import { IGender } from 'types/commonInterfaces';

import { getContent } from './config';

import { useScrollToTop } from 'hookExperiment';

function IndexPage({ toNextPage }: ICommonPageProps): ReactElement {
    useScrollToTop();

    const dispatch = useDispatch();

    const { pageTitles, cardsData } = getContent();

    const handleToNextPage = (gender: IGender) => {
        dispatch(setGender(gender));

        sendAnalyticOptionEventLabel(gender);
        sendGTMStartPageEvent();

        toNextPage();
    };

    const loginClick = () => {
        window.location.href = config.USER_CABINET_URL;

        sendAnalyticLogin();
    };

    return (
        <StartWithCardsContainer
            indexPage
            toNextPage={handleToNextPage}
            pageTitles={pageTitles}
            cardsData={cardsData}
            loginClick={loginClick}
        />
    );
}

export default withStartHOC(IndexPage);
